import 'react-app-polyfill/ie11';
import React, { useEffect, useState, useRef, useContext } from 'react'
import { GlobalContext } from '../Store/GlobalContext'
import Header from '../assets/Components/Header/Header'
import '../LoginPage/LoginPage.css'
import './ForgotPassword.css'
import { ForgotPasswordFormParent } from './ForgotPasswordFormParent';
import axios from 'axios'
import injectCustomCss from './InjectCustomCss'
import '../assets/playStylesheets/partner.css'
import 'bootstrap/dist/css/bootstrap.css'
import '../App.css'
import '../index.css'
import '@fortawesome/fontawesome-free/css/all.css'

const ForgotPassword = ( props ) => {
    const { globalValues, globalDispatch } = useContext( GlobalContext )
    const [ noHeaderFooter, setNoHeaderFooter ] = useState( false )
    const [ params, setParams ] = useState('')
    const [ emailError, setEmailError ] = useState('')
    const [ email , setEmail ] = useState('')
    const [ loading, setLoading ] = useState(true)
    useEffect(()=>{
        checkNoHeaderFooter()
        storeQueryParams()
        getCustomCss()
    },[])

    const checkNoHeaderFooter = () => {
        if( window.hasOwnProperty('NO_HEADER_FOOTER') ){
            setNoHeaderFooter( window.NO_HEADER_FOOTER )
            // dispatchToState( 'SET_NO_HEADER_FOOTER', window.NO_HEADER_FOOTER )
        }
    }

    const getCustomCss = () => {
        axios.get('/apply-now-color')
            .then( (res) => {
                injectCustomCss( res.data.applyNowColorScheme )
            })
            .then(() => {
                setLoading ( false )
            })
    }


    const storeQueryParams = () => {
        if( window.location.search !== '' ){
            setParams( window.location.search )
        }
    }

    // const dispatchToState = ( type, value ) => {
    //     globalDispatch( { type : type, value : value } )
    // }

    return (
        <div className="fullWidthHeight">
            <div id="floify-login-page-main" role="main" className={`${props.noHeaderFooter ? 'fullHeight' : ''} login-form`}>
            { loading ?
                    <div style={{backgroundColor: 'white', height: '100vh'}}></div>
                    :
                    <div>
                            {   !noHeaderFooter &&
                            <Header
                                showLogin={ false }
                                showRegister={ false }
                            />
                        }
                        <div>
                            <ForgotPasswordFormParent
                                noHeaderFooter={noHeaderFooter}
                            />
                        </div>

                    </div>
            }
            </div>
        </div>
    )
}

export default ForgotPassword
